import React from 'react';
import PropTypes from 'prop-types';
import TopBanner from '../TopBanner';
import Gigs from '../Gigs';
import Banner from '../Banner';
import SubcategoryBanners from '../SubcategoryBanners';
import '../styles/index.scss';

export default function ProHomepage({
    sections,
    viewObject,
    requestContext
}) {
    if (typeof sections === 'undefined') { return (null); }

    return (
        <div className="pro-homepage">
            <TopBanner/>

            {sections.map((section, idx) => {
                const { type } = section;

                switch (type) {
                    case 'gigs':
                        return (
                            <Gigs key={idx}
                                categoryId={section.categoryId}
                                subCategoryId={section.subCategoryId}
                                categoryCachedSlug={section.categoryCachedSlug}
                                subCategoryCachedSlug={section.subCategoryCachedSlug}
                                gigs={section.gigs}
                                name={section.name}
                                carouselPosition={idx + 1}
                                viewObject={viewObject}
                                requestContext={requestContext}/>
                        );

                    case 'subcats':
                        const {
                            title,
                            classname,
                            banners
                        } = section;

                        return (
                            <SubcategoryBanners key={idx}
                                title={title}
                                classname={classname}
                                banners={banners}
                                carouselPosition={idx}
                                viewObject={viewObject}/>
                        );

                    case 'banner': {
                        const {
                            title,
                            classname,
                            text,
                            link,
                            image
                        } = section;

                        return (
                            <Banner key={idx}
                                title={title}
                                classname={classname}
                                text={text}
                                link={link}
                                image={image}/>
                        );
                    }

                    default:
                        return null;
                }
            })}
        </div>
    );
}

ProHomepage.propTypes = {
    sections: PropTypes.array,
    requestContext: PropTypes.object
};

ProHomepage.defaultProps = {
    sections: [],
    requestContext: {}
};



// WEBPACK FOOTER //
// ./src/common/HomePage/ProHomepage/index.js